import React from 'react';
import { Select } from '@applyboard/crystal-ui';
import { queryParameterContext } from '../../context';
import { SortAscendingOutlineIcon, SortDescendingOutlineIcon } from '@applyboard/ui-icons';

const sortFields = [
  { label: 'Name (A-Z)', value: 'name', icon: SortAscendingOutlineIcon },
  { label: 'Name (Z-A)', value: '-name', icon: SortDescendingOutlineIcon },
  { label: 'Country (A-Z)', value: 'countryCode', icon: SortAscendingOutlineIcon },
  { label: 'Country (Z-A)', value: '-countryCode', icon: SortDescendingOutlineIcon },
];

export function Sort() {
  const { value, setValue } = queryParameterContext.useFilterField('sort', 'PrimaryFilter');
  const selectedValue = value || 'countryCode';
  const currentField = sortFields.find((field) => field.value === selectedValue);
  const placeholderLabel = currentField ? `Sort: ${currentField.label}` : 'Sort';

  return (
    <Select
      value={selectedValue}
      aria-label="Sort"
      placeholder={placeholderLabel}
      onChange={(value) => setValue(value)}
      emphasis="highlighted"
      intent="primary"
      placeholderVariant="indicator"
      appearance="styled"
    >
      {sortFields.map((field) => (
        <Select.Option key={field.value} label={field.label} value={field.value} icon={field.icon} />
      ))}
    </Select>
  );
}
